import Vue from 'vue'

const bus = new Vue()

function publish() {
  bus.$emit(...arguments)
}

function subscribe() {
  bus.$on(...arguments)
}

function unsubscribe() {
  bus.$off(...arguments)
}

export default { publish, subscribe, unsubscribe }
